import React from "react";
import { Helmet } from "react-helmet";

const SITE_NAME = "Web5Solution";
const SITE_URL = "https://web5solution.com";
const DEFAULT_IMAGE = `${SITE_URL}/logo192.svg`;
const DEFAULT_DESCRIPTION =
  "Web5Solution delivers blockchain, AI, automation, and metaverse development services for businesses building secure, scalable digital products.";
const DEFAULT_KEYWORDS =
  "Web5Solution, blockchain development company, AI development services, automation services, metaverse development company, smart contract development, crypto exchange development";
const TITLE_MAX_LENGTH = 60;

const toAbsoluteUrl = (value = "") => {
  if (!value) return DEFAULT_IMAGE;
  if (/^https?:\/\//i.test(value)) return value;
  return `${SITE_URL}${value.startsWith("/") ? value : `/${value}`}`;
};

const SeoHelmet = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  keywords = DEFAULT_KEYWORDS,
  robots = "index, follow",
  titleSuffix = true,
  truncateTitle = true,
  structuredData,
}) => {
  const canonicalUrl = toAbsoluteUrl(path);
  const imageUrl = toAbsoluteUrl(image);

  const clampTitle = (value = "", maxLength = TITLE_MAX_LENGTH) => {
    const normalized = value.replace(/\s+/g, " ").trim();
    if (normalized.length <= maxLength) return normalized;
    const trimmed = normalized.slice(0, maxLength + 1);
    const lastSpace = trimmed.lastIndexOf(" ");
    return (lastSpace > 25 ? trimmed.slice(0, lastSpace) : trimmed.slice(0, maxLength)).trim();
  };

  const rawTitle = title
    ? !titleSuffix || title.includes(SITE_NAME) || title.includes("Web5 Solution")
      ? title
      : `${title} | ${SITE_NAME}`
    : SITE_NAME;
  const pageTitle = truncateTitle ? clampTitle(rawTitle) : rawTitle;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {structuredData ? (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      ) : null}
    </Helmet>
  );
};

export default SeoHelmet;
